<template>
  <wd-config-provider :themeVars="themeVars">
    <slot />
    <wd-toast />
    <wd-message-box />
    <login-modal />
  </wd-config-provider>
</template>

<script lang="ts" setup>
import LoginModal from '@/components/login-modal.vue'
import type { ConfigProviderThemeVars } from 'wot-design-uni'

const themeVars: ConfigProviderThemeVars = {
  colorTheme: '#612ef3',
  // buttonPrimaryBgColor: '#07c160',
  // buttonPrimaryColor: '#07c160',
}

const flag = ref(false)
onShow(() => (flag.value = true))
onHide(() => (flag.value = false))
</script>

<style lang="scss" scoped>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}

.page-enter-from,
.page-leave-to {
  filter: blur(1rem);
  opacity: 0;
}

.page-enter-to,
.page-leave-from {
  filter: blur(0);
  opacity: 1;
}
</style>
